module.exports = __webpack_public_path__ + "img/icon_white_ticket.dbaaf001.svg";